import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FileService} from "../../services/file-service/file.service";
import {NotificationService} from "../../services/notification-service/notification.service";
import {ImageLightboxComponent, ImageLightboxData} from "../image-lightbox/image-lightbox.component";

@Component({
  selector: 'app-confirm-delete-image',
  templateUrl: './confirm-delete-image.component.html',
  styleUrl: './confirm-delete-image.component.scss'
})
export class ConfirmDeleteImageComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDeleteImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ImageLightboxData,
    private fileService : FileService,
    private notificationService : NotificationService
  ) {  }

  deleteImage(){
    this.fileService.delete(this.data.fileId).subscribe(() => {
      this.notificationService.showSuccess('AUDIT.IMAGE_DELETED');
      this.dialogRef.close()
    })
  }
}
